<template>
    <div class="plans">
        <h1 class="pageHeading">
            <b>PLANS</b> & <b>PRINCING</b>
        </h1>
        <div class="cardSection">
            <div class="col-lg-4 col-md-4 col-sm-4 padding-minus">
                <a href="#topic">
                    <div class="card">
                        <div class="cardHeader">
                            <h1>Startup</h1>
                        </div>
                        <div class="cardBody">
                            <div class="amountSection">
                                <div class="left amount">
                                    <h4>$8.<sub>99</sub></h4>
                                    <p>per month</p>
                                </div>
                                <div class="right amount">
                                    <h4>12</h4>
                                    <p>targets</p>
                                </div>
                            </div>
                            <div class="cardBodyHeader">
                                <p>FEATURES</p>
                            </div>
                            <ul>
                                <li>
                                    <span class="featureHeadind">User</span>
                                    <span class="featureDetail">2 Users</span>
                                </li>
                                <li>
                                    <span class="featureHeadind">Email Alerts</span>
                                    <span class="featureDetail">Unlimited</span>
                                </li>
                                <li>
                                    <span class="featureHeadind">SMS Alerts</span>
                                    <span class="featureDetail">Unlimited</span>
                                </li>
                            </ul>
                        </div>
                        <div class="cardFooter">
                            <ul>
                                <li>
                                    <span class="featureHeadind"><b>PPRICE</b> (Yearly)</span>
                                    <span class="featureDetail">$99.99</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 padding-minus">
                <a href="#topic" class="business">
                    <div class="card">
                        <div class="cardHeader">
                            <h1>Business</h1>
                            <p>MOST POPULAR</p>
                        </div>
                        <div class="cardBody">
                            <div class="amountSection">
                                <div class="left amount">
                                    <h4>$34.<sub>99</sub></h4>
                                    <p>per month</p>
                                </div>
                                <div class="right amount">
                                    <h4>40</h4>
                                    <p>targets</p>
                                </div>
                            </div>
                            <div class="cardBodyHeader">
                                <p>FEATURES</p>
                            </div>
                            <ul>
                                <li>
                                    <span class="featureHeadind">User</span>
                                    <span class="featureDetail">2 Users</span>
                                </li>
                                <li>
                                    <span class="featureHeadind">Email Alerts</span>
                                    <span class="featureDetail">Unlimited</span>
                                </li>
                                <li>
                                    <span class="featureHeadind">SMS Alerts</span>
                                    <span class="featureDetail">Unlimited</span>
                                </li>
                            </ul>
                        </div>
                        <div class="cardFooter">
                            <ul>
                                <li>
                                    <span class="featureHeadind"><b>PPRICE</b> (Yearly)</span>
                                    <span class="featureDetail">$339.99</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 padding-minus">
                <a href="#topic">
                    <div class="card">
                        <div class="cardHeader">
                            <h1>Enterprise</h1>
                        </div>
                        <div class="cardBody">
                            <div class="amountSection">
                                <div class="left amount">
                                    <h4>$79.<sub>99</sub></h4>
                                    <p>per month</p>
                                </div>
                                <div class="right amount">
                                    <h4>100</h4>
                                    <p>targets</p>
                                </div>
                            </div>
                            <div class="cardBodyHeader">
                                <p>FEATURES</p>
                            </div>
                            <ul>
                                <li>
                                    <span class="featureHeadind">User</span>
                                    <span class="featureDetail">2 Users</span>
                                </li>
                                <li>
                                    <span class="featureHeadind">Email Alerts</span>
                                    <span class="featureDetail">Unlimited</span>
                                </li>
                                <li>
                                    <span class="featureHeadind">SMS Alerts</span>
                                    <span class="featureDetail">Unlimited</span>
                                </li>
                            </ul>
                        </div>
                        <div class="cardFooter">
                            <ul>
                                <li>
                                    <span class="featureHeadind"><b>PPRICE</b> (Yearly)</span>
                                    <span class="featureDetail">$949.99</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'plans'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .plans .pageHeading{
        font-size: 32px;
        color: #535861;
        font-weight: lighter;
        margin: 25px 0 50px 0;
    }
    .plans .cardSection{
        margin-bottom: 50px;
        display: inline-block;
        width: 100%;
        margin: 25px 0 50px;
    }
    .plans .cardSection a{
        display: block;
        text-decoration: none;
        transition: 0.5s;
    }
    .plans .cardSection a:hover{
        box-shadow: 0 0 5px -1px black;
        border-radius: 5px;
        transform: scale(0.95);
        position: relative;
        z-index:1;
    }
    .plans .cardSection .card .cardHeader{
        min-height: 70px;
        background-color: #2685dc;
        padding: 22px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 5px 5px 0 0;
    }
    .plans .cardSection .business{
        margin: -25px 5px 0;
    }
    .plans .cardSection .business .cardHeader{
        background-color: #4ec2fc;
    }
    .plans .cardSection .business .cardBody .amountSection h4{
        color: #22b0fc;
    }
    .plans .cardSection .card .cardHeader h1{
        margin:0;
        font-size: 24px;
        color: #ffffff;
    }
    .plans .cardSection .card .cardHeader p{
        margin:5px 0 0 0;
        font-size: 14px;
        color: #ffffff;
    }
    .plans .cardBody{
        display: inline-block;
        width: 100%;
        background-color: #ffffff;
    }
    .plans .cardBody .amountSection{
        padding: 25px  0;
        background: #ffffff;
    }
    .plans .cardBody .amountSection h4{
        font-size: 32px;
        margin: 0;
        font-weight: lighter;
        color:#2d3139
    }
    .plans .cardBody .amountSection h4 sub{
        bottom:0;
    }
    .plans .cardBody .amountSection p{
        font-size: 16px;
        margin: 0;
        color: #8f9baa;
        font-weight: lighter;
    }
    .plans .cardBody .amountSection .amount{
        padding:  0 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .plans .cardBody .amountSection .left{
        width: 55%;
        float: left;
    }
    .plans .cardBody .amountSection .right{
        width: 45%;
        display: inline-block;
    }
    .plans .cardBody .amountSection .right h4{
        color: #5285c8;
    }
    .plans .cardBody .cardBodyHeader{
        background-color: #f4f7f9;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .plans .cardBody .cardBodyHeader p{
        margin: 0;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: #8491a2;
        padding: 12px 28px;
        width: 100%;
    }
    .plans .cardBody ul{
        padding: 0;
        list-style: none;
    }
    .plans .cardBody ul li{
        padding: 15px 25px;
    }
    .plans .cardBody ul li .featureHeadind{
        text-align: left;
        width: 70%;
        float: left;
        border-bottom: 1px solid #f4f7f9;
        color: #8491a2;
        padding-bottom: 10px;
        font-size: 16px;
    }
    .plans .cardBody ul li:last-child .featureHeadind{
        border-bottom: 0 solid transparent;
    }
    .plans .cardBody ul li:last-child{
        padding-bottom: 10px;
    }
    .plans .cardBody ul li .featureDetail{
        text-align: right;
        width: 30%;
        display: inline-block;
        color:#3a3e45;
        font-weight: 600;
        font-size: 16px;
    }
    .plans .cardSection .card .cardFooter{
        min-height: 50px;
        background-color: #2d3139;
        border-radius: 0 0 5px 5px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .plans .cardSection .card .cardFooter ul {
        padding: 10px 25px;
        list-style: none;
        margin: 0;
        width: 100%;
    }
    .plans .cardSection .card .cardFooter ul li{
        width: 100%;
    }
    .plans .cardSection .card .cardFooter ul li .featureHeadind{
        text-align: left;
        width: 70%;
        float: left;
        color: #ffffff;
        font-size: 16px;
    }
    .plans .cardSection .card .cardFooter ul li .featureDetail{
        text-align: right;
        width: 30%;
        display: inline-block;
        color:#ffffff;
        font-weight: 600;
        font-size: 16px;
    }
    .plans .cardSection .card .cardFooter:before{
        content: '';
        border-left: 6px solid #2d3139;
        border-bottom: 6px solid transparent;
        border-top: 6px solid transparent;
        position: absolute;
        top: -5px;
        left: 0;
    }
    .plans .cardSection .card .cardFooter:after{
        content: '';
        border-right: 6px solid #2d3139;
        border-bottom: 6px solid transparent;
        border-top: 6px solid transparent;
        position: absolute;
        top: -5px;
        right: 0;
    }
    .padding-minus{
        padding:0;
    }
</style>



// WEBPACK FOOTER //
// Plans.vue?66a03ca2